import { useModalContext } from '@fourthwall/components';
import React from 'react';
import { PaymentMethodRequiredModalView } from './PaymentMethodRequiredModalView';
export const PaymentMethodRequiredModalContainer = (props) => {
    const { title = 'Add a new payment method', subtitle, submitLabel = 'Save and continue', withChargeLimit = true, onSuccess, onCancel, } = props;
    const { close, open } = useModalContext();
    const handleSuccess = () => {
        close();
        onSuccess();
    };
    const handleAddPaymentMethodClose = () => {
        open(PaymentMethodRequiredModalContainer, props);
    };
    const handleClose = () => {
        close();
        onCancel?.();
    };
    return (React.createElement(PaymentMethodRequiredModalView, { title: title, subtitle: subtitle, submitLabel: submitLabel, withChargeLimit: withChargeLimit, onSuccess: handleSuccess, onClose: handleClose, onAddPaymentMethodClose: handleAddPaymentMethodClose }));
};
